import React from 'react';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import Logo60 from './logo60';
import LogoRegular from './logoRegular';
import { ILogo } from './types';

const Logo: React.FC<ILogo> = props => {
  const is60AnniversaryLogoEnabled = useFlag(LaunchDarklyFlag.ENABLE_60_LOGO);

  const LogoSVG = is60AnniversaryLogoEnabled ? <Logo60 /> : <LogoRegular {...props} />;

  return LogoSVG;
};

export default Logo;
